export const styles = {
	wrapper: {
		position: 'fixed',
		right: '0',
		top: '104px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		background: 'var(--default-white)',
		maxWidth: '440px',
		height: 'calc(100vh - 104px)',
		zIndex: '100',
		boxShadow: 'var(--box-shadow--2)',
		overflow: 'auto',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	menuItem: {
		display: 'flex',
		justifyContent: 'flex-start',
		gap: '12px',
		alignItems: 'center',
		height: '40px',
		padding: '12px 40px',
		fontSize: '18px',
		color: 'var(--neutral-700)',
		lineHeight: '24px',
		transition: '.3s',
		borderRadius: '8px',
		fontWeight: 700,
	},

	btnWrapper: {
		height: '44px',
		'@media (min-width: 768px)': {
			display: 'none',
		},
	},

	backdrop: {
		position: 'fixed',
		top: '104px',
		left: '0',
		right: '0',
		bottom: '0',
		background: 'rgba(0, 0, 0, 0.15)',
		zIndex: '1250',
	},
};
